<template>
  <ReactPage>
    <consumer-raffle-report-page></consumer-raffle-report-page>
  </ReactPage>
</template>

<script>
import ReactPage from '../components/ReactPage.vue';

export default {
  name: "ConsumerRaffleReport",
  components: {
    ReactPage
  }
}
</script>